import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { downloadCsv, extrasSalaryToCsv } from "@/lib/report-export";
import { useExtrasSalaryExport } from "@/hooks/use-extras-salary-export";
import { useCanAccessMenu } from "@/hooks/use-menu-permissions";

/**
 * CSV-eksport av statistlisten (VIB-1283, lønnsdelen — location-bilag-delen
 * er PO-blokkert og parkert). Personnr, kontonr og avtalt beløp per person
 * for statister/eksterne med EKSPLISITT bekreftet payment_type='lonnet'
 * (Erik 21.07, presisert samme dag: uavklart/tom/NULL status skal IKKE med
 * — kun 'faktura' holdes ute var opprinnelig instruks, nå strammet inn til
 * kun-inkluder-lonnet, se src/lib/extras-salary-calc.ts).
 *
 * Synlig for roller med «Statistlønn (CSV-eksport)» på i Systemroller-
 * matrisen. Default er kun admin og superadmin (kravet «kun admin/
 * lønnsansvarlig», Erik 21.07), seedet i migrasjonen som innførte nøkkelen.
 */
export default function ExtrasSalaryExport() {
  const visible = useCanAccessMenu("statistlonn-eksport");
  const { data, isLoading } = useExtrasSalaryExport(visible);

  if (!visible) return null;

  const handleExport = () => {
    if (!data) return;
    const today = new Date().toISOString().slice(0, 10);
    downloadCsv(`statistlonn-${today}.csv`, extrasSalaryToCsv(data));
  };

  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border bg-card px-4 py-3">
      <div>
        <p className="text-sm font-medium">Statistlønn (CSV)</p>
        <p className="text-xs text-muted-foreground">
          Personnr, kontonr og avtalt beløp per statist/ekstern med bekreftet lønnsstatus (uavklart status er utelatt).
        </p>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={handleExport}
        disabled={isLoading || !data || data.length === 0}
      >
        <SrIcon name="download" className="w-3.5 h-3.5 mr-1.5" />
        Eksporter CSV
      </Button>
    </div>
  );
}
